import _random from 'lodash/random';

export class MSRand {
  seed: number;

  constructor(seed: number) {
    this.seed = seed;
  }

  getSeed() {
    return this.seed;
  }

  setSeed(seed: number) {
    this.seed = seed;
  }

  rand() {
    this.setSeed((this.getSeed() * 214013 + 2531011) & 0x7fffffff);
    return (this.getSeed() >> 16) & 0x7fff;
  }

  max_rand(myMax: number) {
    return this.rand() % myMax;
  }

  shuffle(deck: number[]) {
    if (deck.length) {
      let i = deck.length;
      while (--i) {
        let j = this.max_rand(i + 1);
        let tmp = deck[i];
        deck[i] = deck[j];
        deck[j] = tmp;
      }
    }
    return deck;
  }
}

export default function msDeal(seed: number): number[][] {
  const randomizer = new MSRand(seed);
  const num_cols = 8;

  const _perl_range = function (start: number, end: number) {
    const ret = [];

    for (let i = start; i <= end; i++) {
      ret.push(i);
    }

    return ret;
  };

  let columns: number[][] = _perl_range(0, num_cols - 1).map((): number[] => []);
  let deck = _perl_range(0, 4 * 13 - 1);

  randomizer.shuffle(deck);

  deck = deck.reverse();

  for (let i = 0; i < 52; i++) {
    columns[i % num_cols].push(deck[i]);
  }

  return columns;
}
